import React, {useEffect,useState} from 'react';
import "./ShopCategoryDesktop.scss";
import {Col, Row} from "antd";
import {LazyImage} from "../../../Components";
import {useHistory} from "react-router-dom";

const style = {
    background: '#0092ff'
};

function ShopCategoryDesktop({merchant,item, LinkDispatcher}) {

    const history = useHistory()

    const [data,set_data] = useState([])
    useEffect(()=>{
        let cats= JSON.parse(item.items[0].extra_data)
        console.log("cats : ",cats)
        set_data(cats)
    },[])

    const goTo = (id)=>{
        history.push(`/dr-shop/search/${merchant}/${id}`,{cats:data})
        console.log("catId : ",id)
    }

    const defaultImage = "https://test-loyalty-minio.darkube.app/loyalty-media/product/product/images/9a22de82-a7d7-403b-8b14-a2c60e04cda0.jpg"

    return (
        <Row gutter={[16, 4]} justify="center" className="component-row">
            <Col xs={{span: 24}} sm={{span: 24}} md={{span: 24}} lg={{span: 24}}>
                <div className="shop-cat-desktop">
                    {data?.map(cat=>{
                        return(
                            <div className="shop-cat-desktop-item" onClick={e=>{
                                goTo(cat.uid)
                            }}>
                                <img src={cat.image?cat.image:defaultImage} alt=""/>
                                <span>{cat.name}</span>
                            </div>
                        )
                    })}
                </div>
            </Col>
        </Row>
    )
}

export default ShopCategoryDesktop;
